
import { defineComponent, PropType } from 'vue'

// composable
import { useFile } from '@/common/composable/useFile'

// types
import { PretensionFileT } from '@/core/types/pretensions.types'

export default defineComponent({
    props: {
        files: {
            type: Array as PropType<PretensionFileT[]>,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Файлы',
        },
    },
    setup(props, { emit }) {
        const { saveFileByURL } = useFile()

        const isPDF = (url: string) => {
            const url_arr = url.split('.')
            const extension = url_arr[url_arr.length - 1]

            return extension === 'pdf'
        }

        const downloadPretension = async (download_url: string) => {
            saveFileByURL(download_url)
        }

        return { isPDF, downloadPretension }
    },
})
